import PropTypes from 'prop-types';
import React from 'react';

import {reduxForm} from 'redux-form'
import {connect} from 'react-redux'

import AddressForm from '../../components/forms/AddressForm'

import {validateTradePartner as validate} from '../../util/validate'
import {getRecommendedAccountTypes} from "../../selectors/SimpleSelectors";

function ContractPartnerForm(props) {

    const recommendedAccountTypes = Object.keys(props.recommendedAccountTypes).map((key) => {
        return {
            value: key,
            label: props.recommendedAccountTypes[key]
        };
    })

    return <AddressForm id="contractPartner" showTaxID={true} showRecommendedAccount={true} showNote={true} forceValidation={props.forceValidation} recommendedAccountTypes={recommendedAccountTypes}/>;
}

ContractPartnerForm.propTypes = {
    forceValidation: PropTypes.bool
};

ContractPartnerForm.defaultProps = {
    forceValidation: false
};

const mapStateToProps = (state, ownProps) => {

    return {
        recommendedAccountTypes: getRecommendedAccountTypes(state)
    }

}

ContractPartnerForm = reduxForm({form: 'contractPartner', destroyOnUnmount: false, validate})(ContractPartnerForm) // eslint-disable-line

ContractPartnerForm = connect(mapStateToProps)(ContractPartnerForm) // eslint-disable-line

export default ContractPartnerForm



/** WEBPACK FOOTER **
 ** ./src/containers/clientdata/ContractPartnerForm.js
 **/